import {useForm} from 'react-hook-form'
import {useForgotPasswordMutation, useI18n} from 'store/Store'

const useForgotPassword = () => {
    const {i18n} = useI18n()
    const [doForgotPassword, {data: forgotPasswordResponse, error}] =
        useForgotPasswordMutation()

    const responseError = error?.data?.message || error?.data?.message?.message

    const {message: successMessage} = forgotPasswordResponse || {}

    const {
        getValues: getFormValues,
        setValue: setFormValue,
        handleSubmit,
        control: formControl,
        formState: {errors: formErrors},
    } = useForm()

    const onSubmit = (submittedData) => {
        doForgotPassword(submittedData)
    }

    const submit = handleSubmit(onSubmit)
    const translate = (label) => i18n.t('welcome.' + label)

    return {
        formControl,
        submit,
        formErrors,
        getFormValues,
        setFormValue,
        successMessage,
        responseError,
        translate,
    }
}

export default useForgotPassword
